// extracted by mini-css-extract-plugin
export var base = "view-module--base--91803";
export var center = "view-module--center--27f4f";
export var l = "view-module--l--95f80";
export var left = "view-module--left--bb63e";
export var m = "view-module--m--47648";
export var padding = "view-module--padding--f651f";
export var right = "view-module--right--e7309";
export var s = "view-module--s--369cc";
export var xl = "view-module--xl--fef77";